import { Typography } from "@mui/material";
import HeaderBreadcrumbs from "components/HeaderBreadcrumbs";
import { useTranslation } from "react-i18next";
import { PATH_DASHBOARD } from "routes/paths";

const Header = () => {
    const { t } = useTranslation();
    return (
        <>
            <Typography variant="h3" component="h1" paragraph>
                {t("feedbacks")}
            </Typography>
            <HeaderBreadcrumbs
                links={[{ name: t("dashboard"), href: PATH_DASHBOARD.root }, { name: t("feedbacks") }]}
                action={<></>}
                heading={undefined}
                sx={undefined}
            />
        </>
    );
};

export default Header;
